'use strict';

import React from 'react'

import Link   from '@Pure/Link'
import Image  from '@Pure/Image'
import Loader from '@Pure/Loader'

import _ from 'lodash'

const moment = window.moment;

moment.locale('fr');

const numeral = window.numeral;

numeral.locale('en');

const google = window.google;

export default class Geocoder extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			gmap_id: ++app.gmap_id
		};

		this.updateMap        = this.updateMap.bind(this);
		this.searchAddress    = this.searchAddress.bind(this);
		this.startMapIfNeeded = this.startMapIfNeeded.bind(this);
		this.geocode          = this.geocode.bind(this);
		this.handleClick      = this.handleClick.bind(this);
	}

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'documentResized',
			type: 'listener',
			cb: component.updateMap
		});

		if (component.addr_string)
		{
			component.startMapIfNeeded();
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'documentResized',
			type: 'listener',
			cb: component.updateMap
		});
	}

	updateMap (place_id)
	{
		const component = this, props = this.props, state = this.state;

		let request_data = { };

		if (place_id || component.place_id)
		{
			request_data.placeId = place_id || component.place_id;
		}
		else
		{
			request_data.address = getStringFromAddress(props.address);
		}

		component.geocode(request_data);
	}

	searchAddress ()
	{
		const component = this, props = this.props, state = this.state;

		let service = new google.maps.places.PlacesService(component.map);

		service.textSearch(
		{
			query: getStringFromAddress(props.address)
		},
		function (results, status)
		{
			console.info('textSearchAPI => ', results, status);

			if (status === google.maps.places.PlacesServiceStatus.OK)
			{
				let place = results[0];

				if (place && place.place_id)
				{
					component.updateMap(place.place_id);
				}
			}
		});
	}

	startMapIfNeeded ()
	{
		const component = this, props = this.props, state = this.state;

		if (component.map) return;

		const map_div = document.getElementById('gmap-' + component.state.gmap_id);

		component.map = new google.maps.Map(map_div,
		{
			zoom: 5,
			center: { lat: 43.5029078, lng: -1.4928724 }, // France
			gestureHandling: 'cooperative'
		});

		let request_data = { };

		if (props.geocoding)
		{
			request_data.placeId = props.geocoding[0].place_id;
		}
		else
		{
			request_data.address = getStringFromAddress(props.address)
		}

		component.geocode(request_data);
	}

	geocode (request_data)
	{
		const component = this, props = this.props, state = this.state;

		let geocoder = new google.maps.Geocoder();

		component.setState(
		{
			loading: true
		});

		geocoder.geocode(request_data, function (results, status)
		{
			if (status === 'OK')
			{
				if (request_data.placeId)
				{
					component.place_id = request_data.placeId;
				}

				component.map.setCenter(results[0].geometry.location);

				if (!request_data.placeId && !request_data.address)
				{
					component.map.setZoom(5);
				}
				else
				{
					component.map.setZoom(12);
				}

				let marker = new google.maps.Marker(
				{
					position: results[0].geometry.location,
					map: component.map,
					title: (props.address || { }).name ||
						(props.address || { }).line_1 || ''
				});

				if (component.marker)
				{
					component.marker.setMap(null);
				}

				component.marker = marker;

			// Tooltip for the marker
				let tooltip = '<div class="c-gmap__tooltip">' +
					getStringFromAddress(props.address) + '</div>';

				let marker_tooltip = new google.maps.InfoWindow(
				{
					content: tooltip
				});

				marker.addListener('click', function ()
				{
					marker_tooltip.open(component.map, component.marker);
				});

				component.setState(
				{
					loading: false
				});

				if (props.onChange instanceof Function)
				{
					if (!props.geocoding)
					{
						props.onChange(results);
					}
					else if (props.geocoding[0].place_id !== results[0].place_id)
					{
						props.onChange(results);
					}
				}
			}
			else if (status === 'ZERO_RESULTS' && !request_data.placeId)
			{
				component.searchAddress(request_data.address);
			}
			else
			{
				console.error('Error Gmap address search', status, props.address);
			}
		});
	}

	componentDidUpdate ()
	{
		const component = this, props = this.props, state = this.state;

		if (component.addr_string)
		{
			component.startMapIfNeeded();
		}
	}

	handleClick (e)
	{
		const component = this, props = this.props, state = this.state;

		e.preventDefault();

		e.target.blur();

		component.place_id = undefined;

		component.geocode(
		{
			address: getStringFromAddress(props.address)
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const addr_string = getStringFromAddress(props.address);

		let has_changed = false, warn_msg;

		if (!component.addr_string && addr_string)
		{
			if (component.timeout)
			{
				window.clearTimeout(component.timeoutn);
			}

			component.timeout = window.setTimeout(function ()
			{
				component.addr_string = addr_string;

				component.startMapIfNeeded();
			}, 600);
		}
		else if (component.addr_string && component.addr_string !== addr_string)
		{
			has_changed = true;
		}

		if (has_changed === true)
		{
			warn_msg =
			(
				<div className="c-message c-message--orange u-full-width">
					<div className="c-message__content">
						Si vous modifiez l'adresse, cliquez sur le bouton c-dessous afin de mettre à jour le Google Maps.<br />
					</div>
				</div>
			);
		}

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		var output =
		(
			<div className="o-geocoder">

				<div className="o-grid">

					<div className="o-grid__item-4 u-flex u-flex-wrap u-items-center">

						<div className="u-full-width u-text-center ">

							<p className="u-margin-bottom-15 u-text-center">
								{ addr_string }
							</p>

							{ warn_msg }

							<button className="c-btn c-btn--icon" type="button"
								onClick={ component.handleClick }>
								<svg className="o-svg-icon o-svg-icon--tracker c-btn__icon">
									<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
								</svg>
								Géocoder cette adresse
								{ loader }
							</button>

						</div>

					</div>

					<div className="o-grid__item-8">
						<div className="c-gmap" id={ 'gmap-' + state.gmap_id }></div>
					</div>

				</div>

			</div>
		);

		return output;
	}
}

function getStringFromAddress (data={ })
{
	let address = '';

	if (data.name && data.name !== data.line_1)
	{
		address += data.name;
	}

	if (data.line_1)
	{
		if (data.name && data.name !== data.line_1) address += ', ';

		address += data.line_1;
	}

	if (data.zip_code)
	{
		if (data.line_1 || data.name) address += ', ';

		address += data.zip_code;
	}

	if (data.city)
	{
		if (!data.zip_code && (data.line_1 || data.name)) address += ',';

		address += ' ' + data.city;
	}

	return address;
}